// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"18":"dbacbe8fc8b4ba2d","846":"9319ad11bcedf4b0"}[chunkId] + ".css";
};